;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"bb3a468c7c9342e87715e29f4a0b3025efb564d6"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/plp";globalThis["_sentryAssetPrefix"] = "/plp";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:cacheKey\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/:slug*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"cacheKey\",\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"}]}";import * as Sentry from '@sentry/nextjs';
import type { BrowserOptions } from '@sentry/nextjs';
import type { Client } from '@sentry/types';

import sharedSentryOptions from './shared-sentry-options';

export const initSentry = (
    additionalOptions: BrowserOptions
): Client | undefined =>
    Sentry.init({
        ...sharedSentryOptions,
        ...additionalOptions,
    });
